import Apify from '@module/apify';

export default Apify({
  getBillingDetails: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/billing-information',
    method: 'GET',
    pathExt: true,
  },

  updateBillingDetails: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/billing-information',
    pathExt: true,
    method: 'PUT',
  },

  validate: {
    path:
      '/api/v4/nu_subscriptions/{subscriptionId}/billing-information/validate',
    method: 'POST',
    pathExt: true,
  },

  validateUpgrade: {
    path: '/api/v4/nu_subscriptions/billing-information/validate',
    method: 'POST',
    pathExt: true,
  },
});
